import * as types from "./types";
import { StorageService } from "../../services";
import { encrypt } from "../../UtilityFunctions/utils";

export const clearConversation = () => {
  StorageService.remove("conversation");
  return {
    type: types.CLEAR_CONVERSATION,
  };
};

export const setConversation = (conversationData) => {
  StorageService.set("conversation", encrypt(JSON.stringify(conversationData)));

  return {
    type: types.SET_CONVERSATION,
    payload: conversationData,
  };
};
